import type { ReactNode } from 'react';
import { Button, DialogActions, DialogContent } from '@mui/material';
import AppDialog from './AppDialog';
import SpinnerButton from './SpinnerButton';
import { useModalHistory } from '../utils/useModalHistory';

interface ActionDialogProps {
  title: string;
  formId: string;
  saving: boolean;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
  children: ReactNode;
  saveLabel: string;
  cancelLabel: string;
  testId: string;
}

export default function ActionDialog({
  title,
  formId,
  saving,
  onClose,
  onSubmit,
  children,
  saveLabel,
  cancelLabel,
  testId,
}: ActionDialogProps) {
  useModalHistory(onClose);

  return (
    <AppDialog
      open
      title={title}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      confirmLabel={saveLabel}
      confirmFormId={formId}
      confirmDisabled={saving}
      confirmLoading={saving}
      testId={testId}
    >
      <form id={formId} noValidate onSubmit={onSubmit}>
        <DialogContent>{children}</DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="inherit" data-testid="cancel-button">{cancelLabel}</Button>
          <SpinnerButton type="submit" loading={saving} disabled={saving} data-testid="save-button">
            {saveLabel}
          </SpinnerButton>
        </DialogActions>
      </form>
    </AppDialog>
  );
}
